// You can write more code here

/* START OF COMPILED CODE */

import BtnAudio from "../prefabs/btns/BtnAudio";
import UIPositionContainer from "../components/core/UIPositionContainer";
import BtnPlay from "../prefabs/btns/BtnPlay";
/* START-USER-IMPORTS */
import { BaseScene } from '@scarybeasties/phaser-framework-core/scenes';
import { TransitionPoint } from '../app-routing';
import UIButton from '../components/core/UIButton';
import { Sounds } from '../sounds';
/* END-USER-IMPORTS */

export default class Title extends BaseScene {

  constructor() {
    super("Title");

    /* START-USER-CTR-CODE */
    this.bgY = 0;
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // bg
    const bg = this.add.image(960, 384, "title", "bg-title.jpg");

    // btnAudio
    const btnAudio = new BtnAudio(this, 1845, 73.5);
    this.add.existing(btnAudio);

    // btnPlay
    const btnPlay = new BtnPlay(this, 954, 651);
    this.add.existing(btnPlay);

    // title
    const title = this.add.image(959, 83, "title", "logo-looneytunes.png");

    // roadrunner
    const roadrunner = this.add.image(1510, 337, "title", "roadrunner-title.png");

    // bumper
    const bumper = this.add.image(1524, 713, "title", "bumper.png");
    bumper.setOrigin(0.5, 1);

    // impact
    const impact = this.add.image(1298, 451, "title", "impact-fx.png");

    // taz
    const taz = this.add.image(1194, 717, "title", "taz.png");
    taz.setOrigin(0.5, 1);

    // star-1
    const star_1 = this.add.image(1029, 547, "title", "star-1.png");

    // star-2
    const star_2 = this.add.image(1331, 670, "title", "star-2.png");

    // star-3
    const star_3 = this.add.image(1496, 490, "title", "star-3.png");

    // star-4
    const star_4 = this.add.image(1383, 351, "title", "star-4.png");

    // tweety
    const tweety = this.add.image(604, -92, "title", "tweety-title.png");

    // subtitle
    const subtitle = this.add.image(960, 239, "title", "title-eng.png");

    // btnAudio (components)
    const btnAudioUIPositionContainer = new UIPositionContainer(btnAudio);
    btnAudioUIPositionContainer.offsetX = 24;
    btnAudioUIPositionContainer.offsetY = 24;
    btnAudioUIPositionContainer.PinRight = true;
    btnAudioUIPositionContainer.PinTop = true;

    this.bg = bg;
    this.btnAudio = btnAudio;
    this.btnPlay = btnPlay;
    this.title = title;
    this.roadrunner = roadrunner;
    this.bumper = bumper;
    this.impact = impact;
    this.taz = taz;
    this.star_1 = star_1;
    this.star_2 = star_2;
    this.star_3 = star_3;
    this.star_4 = star_4;
    this.tweety = tweety;
    this.subtitle = subtitle;

    this.events.emit("scene-awake");
  }

  private bg!: Phaser.GameObjects.Image;
  private btnAudio!: BtnAudio;
  private btnPlay!: BtnPlay;
  private title!: Phaser.GameObjects.Image;
  private roadrunner!: Phaser.GameObjects.Image;
  private bumper!: Phaser.GameObjects.Image;
  private impact!: Phaser.GameObjects.Image;
  private taz!: Phaser.GameObjects.Image;
  private star_1!: Phaser.GameObjects.Image;
  private star_2!: Phaser.GameObjects.Image;
  private star_3!: Phaser.GameObjects.Image;
  private star_4!: Phaser.GameObjects.Image;
  private tweety!: Phaser.GameObjects.Image;
  private subtitle!: Phaser.GameObjects.Image;

  /* START-USER-CODE */
  protected bgY: number;
  private fireworks!:SpineGameObject;

  public preload() {
    super.preload();
  
    this.load.on(Phaser.Loader.Events.COMPLETE, this.postload, this);
  }

  public postload() {
    super.postload();

    // app.unload(this, assetPack);
  }

  public create() {
    super.create();
    this.editorCreate();

    this.bgY = this.bg.y;

    this.bg.scale = 1.08;
    this.bg.y -= 30;

    this.fireworks = this.add.spine(595, 724, 'titleFireworks', 'idle', true);
    this.fireworks.setDepth(1);

    this.subtitle.setDepth(2);

    this.btnPlay.once(UIButton.events.clicked, () => {
      this.app.App.gotoNextScene(this, TransitionPoint.TitleEnd, { test: 'test' });
    });

    let localisedImage = this.app.LocaleHandler.getLocalisedImageFromId('title', { texture: this.subtitle.texture.key, frame: this.subtitle.frame.name });
    this.subtitle.setTexture(localisedImage.texture, localisedImage.frame);

    this.transitionInInit();
    //this.time.addEvent({ delay: 100, callback: this.transitionIn, callbackScope: this });
    this.transitionIn();


    this.app.AudioHandler.playSound(this, Sounds.Track.DesertMusicLoop, Sounds.Channel.Music, {
      volume: 0.1,
      loop: true
    });
  }

  protected transitionInInit() {
    this.title.scale = 0;
    this.subtitle.scale = 0;
    this.subtitle.angle = 10;
    this.btnPlay.y = 900;
    this.tweety.y = -100;
    this.taz.x = 2243;
    this.bumper.scale = 1;
    this.impact.alpha = 0;
    this.impact.scale = 0.8;

    this.star_1.alpha = 0;
    this.star_1.scale = 0.8;
    this.star_1.x = this.impact.x;
    this.star_1.y = this.impact.y;

    this.star_2.alpha = 0;
    this.star_2.scale = 0.8;
    this.star_2.x = this.impact.x;
    this.star_2.y = this.impact.y;

    this.star_3.alpha = 0;
    this.star_3.scale = 0.8;
    this.star_3.x = this.impact.x;
    this.star_3.y = this.impact.y;

    this.star_4.alpha = 0;
    this.star_4.scale = 0.8;
    this.star_4.x = this.impact.x;
    this.star_4.y = this.impact.y;

    this.roadrunner.alpha = 0;
    this.roadrunner.x = 1624;
    this.roadrunner.y = 500;
  }

  protected transitionIn() {
    this.add.tween({
      targets: this.title,
      scaleX: 0.9,
      scaleY: 0.9,
      duration: 500,
      delay: 250,
      ease: Phaser.Math.Easing.Cubic.Out
    }).on("complete",()=>{
     
    })

    this.fireworks.setAnimation(0,"explosion");
    this.fireworks.addAnimation(0,"loop",true);

    this.add.tween({
      targets: this.subtitle,
      scaleX: 1.1,
      scaleY: 1.1,
      angle:0,
      duration: 1250,
      delay: 400,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.add.tween({
      targets: this.btnPlay,
      y: 639,
      duration: 750,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    this.add.tween({
      targets: this.tweety,
      y: 90,
      duration: 1000,
      delay:500,
      ease: Phaser.Math.Easing.Quadratic.InOut
    });

    this.add.tween({
      targets: this.taz,
      x: 1194,
      duration: 500,
      delay:300,
      ease: Phaser.Math.Easing.Quadratic.InOut
    });

    this.add.tween({
      targets: this.bumper,
      scale:1.1,
      duration: 100,
      delay:400,
      yoyo:true,
      ease: Phaser.Math.Easing.Quadratic.InOut
    });

    this.add.tween({
      targets: this.impact,
      scale:1,
      alpha:1,
      duration: 300,
      delay:400,
      ease: Phaser.Math.Easing.Quadratic.InOut
    });

    this.add.tween({
      targets: this.star_1,
      scale:1,
      x:1029,
      y:547,
      alpha:1,
      duration: 300,
      delay:400,
      ease: Phaser.Math.Easing.Quadratic.InOut
    });

    this.add.tween({
      targets: this.star_2,
      scale:1,
      alpha:1,
      x:1331,
      y:670,
      duration: 300,
      delay:400,
      ease: Phaser.Math.Easing.Quadratic.InOut
    });

    this.add.tween({
      targets: this.star_3,
      scale:1,
      alpha:1,
      x:1496,
      y:490,
      duration: 300,
      delay:400,
      ease: Phaser.Math.Easing.Quadratic.InOut
    });

    this.add.tween({
      targets: this.star_4,
      scale:1,
      alpha:1,
      x:1383,
      y:351,
      duration: 300,
      delay:400,
      ease: Phaser.Math.Easing.Quadratic.InOut
    });

    this.add.tween({
      targets: this.roadrunner,
      x:1510,
      y:337,
      alpha:1,
      duration: 300,
      delay:600,
      ease: Phaser.Math.Easing.Quadratic.InOut
    });

    this.time.addEvent({ delay: 1500, callback: this.startIdles, callbackScope: this });
  }

  protected startIdles() {
    this.add.tween({
      targets: this.subtitle,
      scaleX: 1.125,
      scaleY: 1.125,
      duration: 2000,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });

    this.add.tween({
      targets: this.tweety,
      y: 77,
      duration: 3000,
      loop:-1,
      yoyo:true,
      ease: Phaser.Math.Easing.Quadratic.InOut
    });

    this.add.tween({
      targets: this.taz,
      scaleX: 1.01,
      scaleY: 1.01,
      duration: 4000,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      loop: -1,
      yoyo: true
    });

    this.add.tween({
      targets: this.roadrunner,
      scaleX: 1.02,
      scaleY: 1.02,
      duration: 4500,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      loop: -1,
      yoyo: true
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
